import React, { useState } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import Modal from 'common-ui/modal';
import { selectUserInfo } from 'features/auth/authSlice';
import { bulkAssignLeads } from 'features/newsales/newsalesActions';

import {
  ButtonRow,
  CancelButton,
  ConfirmButton,
  ConfirmText,
  ErrorMessage,
  LeadCountBadge,
  ModalContent,
} from './TakeLeadModal.styles';

const TakeLeadModal = ({ isOpen, leadIds = [], onSuccess, onClose }) => {
  const dispatch = useDispatch();
  const userInfo = useSelector(selectUserInfo);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState('');

  const handleConfirm = async () => {
    setIsSubmitting(true);
    setError('');
    try {
      await dispatch(
        bulkAssignLeads({
          leadIds,
          assigneeUuid: userInfo.uuid,
        })
      ).unwrap();
      if (onSuccess) onSuccess();
      handleClose();
    } catch (err) {
      setError(err?.message || err || 'Failed to take lead');
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleClose = () => {
    setError('');
    onClose();
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={handleClose}
      title="Take Lead"
      footer={false}
      width="400px"
      closeIcon={true}
    >
      <ModalContent>
        <ConfirmText>
          Are you sure you want to take{' '}
          <LeadCountBadge>
            {leadIds.length} lead{leadIds.length !== 1 ? 's' : ''}
          </LeadCountBadge>{' '}
          and assign {leadIds.length !== 1 ? 'them' : 'it'} to yourself?
        </ConfirmText>

        {error && <ErrorMessage>{error}</ErrorMessage>}

        <ButtonRow>
          <CancelButton onClick={handleClose} disabled={isSubmitting}>
            Cancel
          </CancelButton>
          <ConfirmButton onClick={handleConfirm} disabled={isSubmitting}>
            {isSubmitting ? 'Taking...' : 'Confirm'}
          </ConfirmButton>
        </ButtonRow>
      </ModalContent>
    </Modal>
  );
};

export default TakeLeadModal;
